var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isCookieAccepted
    ? _c("div", { staticClass: "cookie-popup" }, [
        _c("div", { staticClass: "cookie-content" }, [
          _vm._m(0),
          _c(
            "button",
            { staticClass: "accept-btn", on: { click: _vm.acceptCookies } },
            [_vm._v("הבנתי")]
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cookie-text" }, [
      _c("p", [
        _vm._v(
          'הפרטיות שלכם חשובה לנו. לידיעתכם, באתר זה נעשה שימוש בקבצי "עוגיות" (cookies) וכלים דומים במטרה לשפר את חווית הגלישה, לספק תוכן מותאם אישית ולבצע ניתוחים סטטיסטיים. למידע נוסף ניתן לעיין ב'
        ),
        _c(
          "a",
          {
            staticClass: "privacy-link",
            attrs: { href: "/privacy.html", target: "_blank" }
          },
          [_vm._v("מדיניות הפרטיות")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }